export const attendee = {};

export const admin = {
    groupDetails: (roomSlug: string, groupId: string): string =>
        `/administrator/rooms/${roomSlug}/members/group/${groupId}/`,
    members: (roomSlug: string): string => `/administrator/rooms/${roomSlug}/members/`
};

export const api = {
    organisations: (): string => '/api/organisations/',
    member: (uuid: string): string => `/api/members/${uuid}/`,
    memberInvite: (uuid: string): string => `/api/members/${uuid}/invite/`,
    memberGroups: (uuid: string): string => `/api/members/${uuid}/groups/`,
    memberGroup: (memberUuid: string, groupUuid: string): string =>
        `/api/members/${memberUuid}/groups/${groupUuid}/`,
    memberAssistant: (memberUuid: string, assistantId?: string): string =>
        `/api/members/${memberUuid}/assistants/${assistantId ? `${assistantId}/` : ''}`,
    complianceConsent: (roomId: string, messageId: string): string =>
        `/api/rooms/${roomId}/member-consent/${messageId}/store/`,
    group: (groupId: string): string => `/api/groups/${groupId}/`,
    groupManagersPicker: (): string => `/api/groups/manager_picker/`,
    groupMembersPicker: (): string => `/api/groups/member_picker/`,
    groups: (): string => '/api/groups/',
    groupsShow: (): string => '/api/groups/show/',
    members: (): string => '/api/members/',
    manageableGroups: (): string => '/api/groups/manageable/',
    manageableMembers: (): string => '/api/members/manageable/',
    membersShow: (): string => '/api/members/show/',
    userProfilePhoto: (): string => '/api/me/profile-picture/',
    validateEmail: (roomId: string) => `/api/rooms/${roomId}/validate-email/`,
    notificationsPreferences: (): string => '/api/me/user-notification-preference/',
    notificationCategoryPreferences: (category: string): string =>
        `/api/me/user-notification-preference/${category}/`,
    meetingCheckInPreferences: (roomId: string): string =>
        `/api/me/easy-check-in-preference/?room_id=${roomId}`,
    memberSecondFactorReset: (memberId: string): string =>
        `/api/members/${memberId}/reset-second-factor/`,
    resetRequests: (token: string): string => `/api/reset-requests/${token}/`,
    switchAssisted: (memberId: string): string => `/api/members/${memberId}/switch-assisted/`,
    request2FAResetLink: (): string => '/api/users/request-second-factor-reset/'
};

export const adminPortal = {
    groupDetails: (organisationSlug: string, roomSlug: string, groupId: string): string =>
        `/organisations/${organisationSlug}/members/${roomSlug}/group/${groupId}/`,
    members: (organisationSlug: string, roomSlug: string): string =>
        `/organisations/${organisationSlug}/members/${roomSlug}/`,
    organisations: (slug?: string | string[]): string => `/organisations/${slug || ''}`
};
